function setupEqualHeights() {

    const CARD_THUMB = '.grid__item > .postbox > .postbox__thumb';

    function equalizeThumbnails() {
        const thumbs = document.querySelectorAll(CARD_THUMB);
        if (thumbs.length === 0) return;

        const grids = new Map();
        thumbs.forEach(thumb => {
            const grid = thumb.closest('.grid') || document.body;
            if (!grids.has(grid)) grids.set(grid, []);
            grids.get(grid).push(thumb);
        });

        grids.forEach(group => {
            group.forEach(thumb => thumb.style.height = '');
            if (group.length < 2) return;

            let tallest = 0;
            group.forEach(thumb => {
                const img = thumb.querySelector('img');
                if (!img) return;
                const ratio = parseFloat(img.getAttribute('data-aspectratio')) ||
                    (img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 0);
                const height = ratio > 0 ? thumb.clientWidth / ratio : img.offsetHeight;
                if (height > tallest) tallest = height;
            });

            if (tallest > 0) {
                group.forEach(thumb => thumb.style.height = Math.ceil(tallest) + 'px');
            }
        });
    }

    function equalizeHeights() {
        equalizeThumbnails();

        const elements = document.querySelectorAll('.make-equal-height');
        if (elements.length === 0) return;

        elements.forEach(el => el.style.height = 'auto');

        let maxHeight = 0;
        elements.forEach(el => {
            const height = el.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        if (maxHeight > 0) {
            elements.forEach(el => {
                el.style.height = maxHeight + 'px';
            });
        }
    }

    function scheduleEqualizeHeights() {
        clearTimeout(window.equalHeightResize);
        window.equalHeightResize = setTimeout(equalizeHeights, 250);
    }

    setTimeout(equalizeHeights, 150);

    window.addEventListener('resize', scheduleEqualizeHeights);

    window.addEventListener('load', scheduleEqualizeHeights);
    document.addEventListener('lazyloaded', scheduleEqualizeHeights);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleEqualizeHeights);
    }

    window.equalizeHeights = equalizeHeights;
}

document.addEventListener('DOMContentLoaded', setupEqualHeights);
